import React from 'react';

const variantClasses = {
  default: 'glass-card',
  elevated: 'glass-card glass-card--elevated',
  subtle: 'glass-card glass-card--subtle',
};

const GlassCard = ({ children, variant = 'default', className = '', onClick, style }) => {
  const baseClass = variantClasses[variant] || variantClasses.default;
  const combinedClass = `${baseClass} ${className}`.trim();

  return (
    <div className={combinedClass} onClick={onClick} style={style}>
      {children}
    </div>
  );
};

export default GlassCard;
